import styled, { css } from 'styled-components'
import { colors } from '../../const'

export const Container = styled.section`
  display: flex;
  flex-direction: column;
  height: 720px;
  width: 1280px;
`

export const Header = styled.div`
  background-color: ${colors.primary};
  display: grid;
  grid-template-columns: repeat(3, 1fr);
  padding: 20px;
`

export const HeaderItem = styled.div(
  ({ position = 'flex-start' }) => css`
    color: ${colors.surface};
    font-size: 28px;
    justify-self: ${position};
  `
)

export const HeaderDetailWrapper = styled.div`
  display: flex;
  flex-direction: column;
  gap: 6px;
  padding: 0 10%;
`

export const HeaderDetailRow = styled.div`
  color: ${colors.surface};
  display: flex;
  justify-content: space-between;
  gap: 10px;
`

export const HeaderField = styled.p`
  font-weight: 600;
  margin: 0;
`

export const HeaderValue = styled.p`
  margin: 0;
`
